import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MiscService } from '../../_service/misc.service';
import { LeadsService } from 'src/app/_service/leads.service';
import { DoctorService } from 'src/app/_service/doctor.service';
import * as XLSX from 'xlsx';
declare var $: any;
@Component({
  selector: 'app-master-pin-code-list',
  templateUrl: './master-pin-code-list.component.html',
  styleUrls: ['./master-pin-code-list.component.css']
})
export class MasterPinCodeListComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('csvUpload', { static: false }) csvUpload: ElementRef;

  perpage: number = 25; pincodeList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; circles_copy = []; circles = []; circle = '';sc3Url:string='';
  search_pincode = ''; zones: any; zone = ''; zones_copy: any; circle_zone: boolean = true;uploaded_msg: string = '';submitted: boolean = false;
  constructor(public doctorapi: DoctorService, private sharedapi: SharedService, public miscapi: MiscService, public leadapi: LeadsService) { }

  ngOnInit(): void {
    this.sc3Url= localStorage.getItem('s3url');
    this.getcircle();
  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  async getCircleZone(circle_id) {
    this.zone = '';
    let qString = 'circle=' + circle_id;
    await this.miscapi.getCircle_zone(qString).subscribe((data: any) => {
      if (data.status) {
        this.zones = data.data;
        this.zones_copy = this.zones;
        this.circle_zone = false;
      } else {
        this.zones = [];
        this.circle_zone = false;
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }
  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } else if (type == 'zones') {
      this.zones = this.sharedapi.searchData(searchtText, this.zones_copy, "name");
    }
  }

  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    } else if (type == 'zone') {
      $("#zoneSearch").val('');
      $("#zoneSearch").focus();
      this.zones = this.zones_copy;
    }
  }

  ngAfterViewInit() {
    this.loadPinCodeList(0, this.perpage);
  }

  async loadPinCodeList(pageIndex, perpage) {
    this.pincodeList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search_pincode + '&circle=' + this.circle + '&zone=' + this.zone;
    this.loading = true; this.loaded = false;
    await this.miscapi.getPinCodeList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.pincodeList = data.data;
      } else {
        this.pincodeList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadPinCodeList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadPinCodeList(event.pageIndex, event.pageSize);
  }

  resetFilters() {
    this.search_pincode = ''; this.circle = ''; this.zone = '';
    this.loadPinCodeList(0, 25);
  }
  //=====Export List=====//
  exportPinCodeList() {
    if (this.pincodeList.length > 0) {
      let data = [];
      let titles = ['Circle Name', 'Zone Name', 'Pin Code'];

      data.push(titles);

      for (let key in this.pincodeList) {
        let extData = [this.pincodeList[key].circle_name, this.pincodeList[key].zoneName, this.pincodeList[key].pincode];
        data.push(extData)
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      XLSX.writeFile(wb, 'pincodelist_' + utc + '.xlsx');
    } else {
      this.sharedapi.presentToast('No Pin Code Data found!');
    }
  }

  // ======csv============//
  hideModal() {
    this.uploaded_msg = '';
    $('#myModal').modal('hide');
  }

  showModal() {
    this.uploaded_msg = '';
    $('#myModal').modal();
  }

  async selectFile(event) {
    this.submitted = true;
    let file = event.target.files.item(0);
    const formData = new FormData();
    formData.append('file', file);
    this.uploaded_msg = "";
    this.miscapi.uploadPincodecsv(formData).subscribe((data: any) => {
      this.submitted = false;
      this.csvUpload.nativeElement.value = "";
      if (data.status) {
        this.uploaded_msg = data.msg;
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }



}
